export default __webpack_public_path__ + "static/media/highlight.280b5e79.png";